import { render, staticRenderFns } from "./CargoRecord.vue?vue&type=template&id=684a3b6f&scoped=true&"
import script from "./CargoRecord.vue?vue&type=script&lang=js&"
export * from "./CargoRecord.vue?vue&type=script&lang=js&"
import style0 from "./CargoRecord.vue?vue&type=style&index=0&id=684a3b6f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a3b6f",
  null
  
)

export default component.exports